export enum BadgeVariant {
    Gray = 'gray',
    Pink = 'pink',
    Purple = 'purple',
    Teal = 'teal',
    Lime = 'lime',
    Orange = 'orange',
    Magenta = 'magenta',
}

export enum ChipSize {
    Sm = 'sm',
    Md = 'md',
    Lg = 'lg',
}

export enum ChipPosition {
    TopLeft = 'top-left',
    TopRight = 'top-right',
    BottomLeft = 'bottom-left',
    BottomRight = 'bottom-right',
}

export enum ButtonVariant {
    Link = 'link',
    White = 'white',
    White_2c94ff = 'white-2c94ff',
    White_086efb = 'white-086efb',
    White_eff6ff = 'white-eff6ff',
    Lake = 'lake',
    Primary = 'primary',
    Warning = 'warning',
    Danger = 'danger',
    Coral = 'coral',
}

export enum SwitchSize {
    Sm = 'sm',
    Md = 'md',
    Lg = 'lg',
}

export enum SwitchColor {
    Primary = 'primary',
    Warning = 'warning',
    Default = 'default',
}

export enum ColorfulTabVariant {
    Default = 'default',
    Lake = 'lake',
    Shamrock = 'shamrock',
    Blossom = 'blossom',
}

export enum TooltipPosition {
    Left = 'left',
    Right = 'right',
    Top = 'top',
    Bottom = 'bottom',
}

export enum TooltipVariant {
    Primary = 'primary',
    Warning = 'warning',
}

export enum ModalSize {
    Sm = 'sm',
    Md = 'md',
}

export enum ModalTitleAlign {
    Left = 'left',
    Center = 'center',
}

export enum NotificationType {
    Basic = 'basic',
    Warning = 'warning',
    Danger = 'danger',
}

export enum NotificationDirection {
    TopLeft = 'top-left',
    Top = 'top',
    TopRight = 'top-right',
    Left = 'left',
    Center = 'center',
    Right = 'right',
    BottomLeft = 'bottom-left',
    Bottom = 'bottom',
    BottomRight = 'bottom-right',
}

export enum ScrollBehaviorMode {
    Auto = 'auto',
    Instant = 'instant',
    Smooth = 'smooth',
}

export enum SidebarActiveScrollPosition {
    Top = 'top',
    Center = 'center',
}

export enum SidebarPosition {
    Left = 'left',
    Right = 'right',
}

export enum DrawerPosition {
    Left = 'left',
    Right = 'right',
    Top = 'top',
    Bottom = 'bottom',
}

export enum DrawerTheme {
    Dark = 'dark',
    Light = 'light',
}

export enum DrawerState {
    Closed = 'closed',
    Opening = 'opening',
    Open = 'open',
    Closing = 'closing',
}

export enum SectionEmptyState {
    Default = 'default',
    Loading = 'loading',
    Timeout = 'timeout',
    Error = 'error',
}

export enum FileUploadStyleVariant {
    Simple = 'simple',
    Full = 'full',
}

export enum FlipbookBookPageType {
    FrontCover = 'frontcover',
    AdPage = 'adpage',
    InnerPage = 'innerpage',
    BackCover = 'backcover',
}

export enum FlipbookDirection {
    Left = 'left',
    Right = 'right',
}

export enum FlipbookBookDirection {
    Ltr = 'ltr',
    Rtl = 'rtl',
}

export enum FlipbookWheelMode {
    Scroll = 'scroll',
    Zoom = 'zoom',
}

export enum TableColumnAlign {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}

export enum FormSelectFixedDirection {
    None = '',
    Up = 'up',
    Down = 'down',
}

export enum TwzipcodeCategory {
    County = 'county',
    District = 'district',
}

export enum PlusMinusClickMode {
    Add = 'add',
    Subtract = 'subtract',
}

export enum DateTimePickerType {
    Date = 'date',
    Time = 'time',
    DateTime = 'datetime-local',
}

export enum DialDirection {
    Up = 'up',
    Down = 'down',
}

export interface BreadcrumbNodeItem {
    name: string;
    url: string;
}

export interface BookshelfCatalogItem {
    CatalogID: number | string;
    CatalogName: string;
    Description: string;
    Thumbnail: string;
}

export interface StepWizardItem {
    title: string;
}

export type InputChoiceValue = string | number | boolean;

export interface InputChoiceOption {
    value: InputChoiceValue;
    label: string;
    disabled?: boolean;
}

export interface FormSelectOption {
    value: string | number;
    label: string;
}

export enum FileUploadStatus {
    Queued = 'queued',
    Uploading = 'uploading',
    Done = 'done',
    Error = 'error',
}

export interface FileUploadFileInfo {
    uid: string;
    originalName?: string;
    name: string;
    size: number;
    sizeText: string;
    type: string;
    lastModified: number;
    rawFile: File | null;
    status: FileUploadStatus | string;
    validation: {
        sizeExceeded: boolean;
    };
}

export type FileUploadModelValue =
    FileUploadFileInfo | FileUploadFileInfo[] | null;

export interface FileUploadResponseRecord {
    [key: string]:
        | string
        | number
        | boolean
        | null
        | FileUploadResponseRecord
        | FileUploadResponseRecord[];
}

export type FileUploadResponseValue =
    string | number | boolean | null | FileUploadResponseRecord;

export interface FileUploadHandlerPayload {
    FileInfos: FileUploadFileInfo[];
    Files: File[];
}

export interface FileUploadChunkPayload {
    file: File;
    fileInfo?: FileUploadFileInfo;
    chunk: Blob;
    chunkIndex: number;
    totalChunks: number;
}

export interface FileUploadErrorItem {
    type: string;
    message: string;
    files: string[];
}

export interface FileUploadChangePayload {
    FileInfos: FileUploadFileInfo[];
    UploadedFileInfos: FileUploadFileInfo[];
    errors: string[];
    errorItems: FileUploadErrorItem[];
}

export interface FileUploadConfig {
    styleVariant?: FileUploadStyleVariant;
    style?: FileUploadStyleVariant;
    accept?: string;
    multiple?: boolean;
    maxSizeBytes?: number;
    maxCount?: number;
    strictSizeLimit?: boolean;
    autoUpload?: boolean;
    // uploadHandler 失敗時的最大重試次數，預設 0 表示不重試
    uploadRetries?: number;
    // 每次重試前的等待毫秒數，預設 1000
    uploadRetryDelay?: number;
    // 分片大小 (bytes)，設定後改由元件切片並逐片呼叫 chunkUploadHandler
    chunkSize?: number;
    appendOnSelected?: boolean;
    showFileList?: boolean;
    buttonText?: string;
    buttonVariant?: ButtonVariant;
    uploadButtonText?: string;
    uploadButtonVariant?: ButtonVariant;
    hintText?: string;
    dropTitle?: string;
    dropDescription?: string | string[];
    emptyText?: string;
    // 整檔上傳 handler，每次帶入一個檔案；多檔時最多同時執行 5 份
    uploadHandler?: (
        payload: FileUploadHandlerPayload
    ) => Promise<FileUploadResponseValue>;
    // 逐片上傳 handler，搭配 chunkSize 使用；單檔逐片 await，多檔時最多同時處理 5 份
    chunkUploadHandler?: (
        payload: FileUploadChunkPayload
    ) => Promise<FileUploadResponseValue>;
}

export interface TooltipContentClassMap {
    [className: string]: boolean;
}

export interface TooltipContentStyleMap {
    [styleKey: string]: string;
}

export interface ComponentValueMap {
    [key: string]:
        | string
        | number
        | boolean
        | null
        | undefined
        | Array<string | number | boolean | null | undefined>
        | ComponentValueMap
        | ComponentValueMap[];
}

export type MenuIdValue = string | number;

export type MenuIdMapValue = MenuIdValue | MenuIdValue[];

export interface MenuIdMap {
    [key: string]: MenuIdMapValue;
}

export interface MenuItem extends ComponentValueMap {
    value?: string | number;
    label?: string | number;
    code?: string | number;
    svg?: string;
    image?: string;
    imageAlt?: string;
    title?: string;
    signoff?: string | number;
    selectable?: boolean | string;
    url?: string;
    children?: MenuItem[];
}

export interface MenuSelectPayload {
    item: MenuItem;
    level: number;
    itemId: string | number;
    itemName: string;
    itemCode: string;
    hasChildren: boolean;
    activeIdMap?: MenuIdMap;
    expandedIdMap?: MenuIdMap;
}

export interface MenuTogglePayload extends MenuSelectPayload {
    nextExpandedId?: MenuIdValue | '';
}

export interface SidebarMenuPayload {
    item?: MenuItem | null;
    itemId?: string | number;
    level?: number;
    activeIdMap?: MenuIdMap;
    expandedIdMap?: MenuIdMap;
}

export interface SectionFrameSidebarChangePayload {
    item?: MenuItem | null;
    itemId?: string | number;
    sidebarContext: string | number | ComponentValueMap;
}

export interface TableColumn {
    key: string;
    label: string;
    width?: string;
    align?: TableColumnAlign;
}

export interface TableRow {
    [key: string]: string | number | boolean | null | undefined;
}

export interface TableData {
    columns: TableColumn[];
    rows: TableRow[];
}

export interface ModalOptions {
    title?: string;
    body?: string;
    allowMultiple?: boolean;
    showReject?: boolean;
    showConfirm?: boolean;
    cancelText?: string;
    confirmText?: string;
    onResolve?: (() => void) | null;
    onReject?: (() => void) | null;
    size?: ModalSize;
    width?: string | null;
    closeOnOverlay?: boolean;
    closeOnEsc?: boolean;
    titleAlign?: ModalTitleAlign;
    isStatic?: boolean;
}

export interface NotificationOptions {
    direction?: NotificationDirection;
    stack?: boolean;
    persistent?: boolean;
    timeout?: number;
    closable?: boolean;
    title?: string;
    body?: string;
    icon?: string;
}

export interface NotificationItem {
    id: string;
    type: NotificationType;
    title: string;
    body: string;
    icon: string;
    timeout: number;
    closable: boolean;
    persistent: boolean;
    stack: boolean;
}

export interface FlipbookFrameItem {
    pagenum?: number | string;
    link?: string;
    type?: string;
    page_number?: number | string;
    image_url?: string;
    page_type?: string;
    is_chapter?: boolean;
    isChapter?: boolean;
    chapter_title?: string;
    chapterTitle?: string;
    title?: string;
}

export interface CollapseTogglePayload {
    isOpen: boolean;
}

export interface DialItem {
    iconName: string;
    action?: () => void;
}
